/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface SkincareCountInterface {
  "cleaningCount": number;
  "protectionCount": number;
  "careCount": number;
  "date": Date;
  "id"?: any;
  "patientId"?: any;
  patient?: Patient;
}

export class SkincareCount implements SkincareCountInterface {
  "cleaningCount": number;
  "protectionCount": number;
  "careCount": number;
  "date": Date;
  "id": any;
  "patientId": any;
  patient: Patient;
  constructor(data?: SkincareCountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SkincareCount`.
   */
  public static getModelName() {
    return "SkincareCount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SkincareCount for dynamic purposes.
  **/
  public static factory(data: SkincareCountInterface): SkincareCount{
    return new SkincareCount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SkincareCount',
      plural: 'SkincareCounts',
      path: 'SkincareCounts',
      idName: 'id',
      properties: {
        "cleaningCount": {
          name: 'cleaningCount',
          type: 'number',
          default: 0
        },
        "protectionCount": {
          name: 'protectionCount',
          type: 'number',
          default: 0
        },
        "careCount": {
          name: 'careCount',
          type: 'number',
          default: 0
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
